export   const depthDate =  [
    {
        'name':"Profondeur Aujourd'hui",
        'value':"0"
    },
    {
        'name':"Profondeur Hier",
        'value':"1"
    },
    {
        'name':"Profondeur 4 jours",
        'value':"4"
    },
    {
        'name':"Profondeur 7 jours",
        'value':"7"
    },
    {
        'name':"Profondeur 15 jours",
        'value':"15"
    },
    {
        'name':"Profondeur 1 mois",
        'value':"31"
    },
    {
        'name':"Profondeur 2 mois",
        'value':"61"
    },
    {
        'name':"Profondeur 3 mois",
        'value':"93"
    },
    {
        'name':"Profondeur 6 mois",
        'value':"186"
    },
    {
        'name':"Profondeur 12 mois",
        'value':"365"
    },
    {
        'name':"Profondeur 15 mois",
        'value':"450"
    },
    {
        'name':"Profondeur 26 mois",
        'value':"790"
    }
]

     